var _NumberFormatter_delegates, _NumberFormatter_getFormatter;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import FormatException from '../Exceptions/FormatException';
import NumberFormatterDelegates from "./NumberFormatterDelegates";
import isNullOrEmpty from '../TypeHelpers/isNullOrEmpty';
import * as DefaultConfiguration from '../i18n/en/NumberFormatterConfiguration.strings.json';
/** Formats numbers */
export default class NumberFormatter {
    constructor(numberFormatterDelegates = new NumberFormatterDelegates(DefaultConfiguration)) {
        _NumberFormatter_delegates.set(this, void 0);
        _NumberFormatter_getFormatter.set(this, (specifier) => {
            switch (specifier.toLowerCase()) {
                case 'c': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatCurrency;
                case 'd': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatInteger;
                case 'e': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatExponential;
                case 'f': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatFixed;
                case 'g': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatGeneral;
                case 'n': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatNumber;
                case 'p': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatPercent;
                case 'x': return __classPrivateFieldGet(this, _NumberFormatter_delegates, "f").formatHexadecimal;
                default: throw new FormatException(`The format specifier '${specifier}' is not implemented`);
            }
        });
        __classPrivateFieldSet(this, _NumberFormatter_delegates, numberFormatterDelegates, "f");
    }
    format(subject, format) {
        if (isNullOrEmpty(format)) {
            return subject.toString();
        }
        else {
            const [specifier, precision] = [format.charAt(0), parseInt(format.slice(1)) || undefined];
            return __classPrivateFieldGet(this, _NumberFormatter_getFormatter, "f").call(this, specifier).call(__classPrivateFieldGet(this, _NumberFormatter_delegates, "f"), subject, precision);
        }
    }
}
_NumberFormatter_delegates = new WeakMap(), _NumberFormatter_getFormatter = new WeakMap();
